<template>
<div class="w-full">

    <div id="seccionImprimir2" class="contenedor-cert">
        <img src="../../../assets/images/seminarios/diploma2.jpg" style="width: 100%; -webkit-print-color-adjust: exact; print-color-adjust: exact;">

        <!-- Nombre del docente -->
        <div style="font-family: font_diploma; font-size: 45px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); white-space: nowrap;">
            {{ usuario.nombres }} {{ usuario.apellidos }}
        </div>

        <!-- Título de la capacitación o encuesta -->
        <div align="center">
            <div style="font-family: font_diploma; line-height: 80%; font-size: 38px; width: 90%; position: absolute; top: 66%; left: 50%; transform: translate(-50%, -50%);">
                {{ nombreCapacitacion || encuesta.titulo }}
            </div>
        </div>

        <!-- Fecha -->
        <div style="width: 100%; padding-right: 130px; text-align: right; font-family: font_diploma; font-size: 30px; position: absolute; top: 79%; left: 50%; transform: translate(-50%, -50%);">
            {{ fechaHoy }}
        </div>

        <!-- Firma del Capacitador -->
        <div v-if="firmaCapacitador" style="position: absolute; bottom: 8%; right: 20%; width: 200px; height: 80px; display: flex; align-items: center; justify-content: center;">
            <img :src="$data_url + 'archivos/usuarios/firmas/' + firmaCapacitador"
                 alt="Firma Capacitador"
                 style="max-width: 100%; max-height: 100%; object-fit: contain; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
        </div>
    </div>

    <vs-popup title="Sigue estos pasos para descargar tu certificado" :active.sync="popupActivo">
        <img src="../../../assets/images/seminarios/tutorialDescarga.png" style="width: 100%;"><br><br>
        <vs-button color="primary" class="w-full mb-1" type="gradient" @click="descargarCertificado()">Descargar</vs-button>
    </vs-popup>

</div>
</template>

<script>
export default {
    data() {
        return {
            popupActivo: true,
            usuario:  { nombres: '', apellidos: '' },
            encuesta: { titulo: '', codigo: '' },
            nombreCapacitacion: '',
            firmaCapacitador: null,
        }
    },
    computed: {
        fechaHoy() {
            const d = new Date()
            const meses = ['enero','febrero','marzo','abril','mayo','junio',
                           'julio','agosto','septiembre','octubre','noviembre','diciembre']
            return `${d.getDate()} de ${meses[d.getMonth()]} de ${d.getFullYear()}`
        }
    },
    mounted() {
        try {
            const u = localStorage.getItem('userEncuestaProlipa')
            const e = localStorage.getItem('dataEncuestaCertificado')
            const n = localStorage.getItem('nombreEntidadEncuesta')
            const f = localStorage.getItem('firmaCapacitadorEncuesta')
            if (u) this.usuario  = JSON.parse(u)
            if (e) this.encuesta = JSON.parse(e)
            if (n) this.nombreCapacitacion = n
            if (f) this.firmaCapacitador = f
            // Limpiar para que no persista en futuras visitas
            // localStorage.removeItem('nombreEntidadEncuesta')
            // localStorage.removeItem('firmaCapacitadorEncuesta')
        } catch(err) {}
        this.valPopupDesc()
    },
    methods: {
        valPopupDesc() {
            setTimeout(() => {
                if (!this.popupActivo) {
                    this.popupActivo = true
                }
            }, 3000)
        },
        descargarCertificado() {
            this.popupActivo = false
            const nombreArchivo = 'certificado_' + (this.encuesta.codigo || 'encuesta').replace('ENC_', 'CAP_')
            document.title = nombreArchivo

            // Registrar descarga en el backend
            try {
                const payload = {
                    encuesta_id: this.encuesta.id,
                    usuario_id:  this.usuario.idusuario,
                }
                const asignacionId = localStorage.getItem('asignacionIdEncuesta')
                if (asignacionId) payload.asignacion_id = asignacionId

                this.$http.post(this.$server_url + 'encuesta_prolipa/registrar-descarga', payload)
                    .catch(() => {}) // silencioso, no bloquear la descarga
            } catch(e) {}

            setTimeout(() => {
                window.print()
            }, 1000)
        }
    }
}
</script>

<style>
@font-face {
    font-family: "font_diploma";
    src: url("../../../assets/images/seminarios/SavoyePlain.otf");
}
.contenedor-cert {
    position: relative;
    display: inline-block;
    text-align: center;
    width: 100%;
}
@media print {
    .vs-popup--background,
    .vs-popup--content {
        display: none !important;
    }
}
</style>
